import {api, handleApiError, ServiceResponse} from "../ApiClient";

export interface Club {
    id: string
    name: string
    verified: boolean
}

export interface GetClubsResponse extends ServiceResponse {
    clubs?: Club[]
}

export interface ClubResponse extends ServiceResponse {
    club?: Club
}

export const ClubService = () => {

    const getAll = (): Promise<GetClubsResponse> => {
        return api.get<Club[]>(`/api/1/clubs`)
            .then((resp) => {
                if (resp && resp.status === 200 && resp.data) {
                    return {
                        clubs: resp.data
                    }
                }

                return {
                    error: {
                        message: 'Could not create session.'
                    }
                }
            })
            .catch(handleApiError)
    };

    const create = (name: string): Promise<ClubResponse> => {
        return api.post<Club>(`/api/1/club`, {
            name
        })
            .then((resp) => {
                if (resp && resp.status === 200 && resp.data) {
                    return {
                        club: resp.data
                    }
                }

                return {
                    error: {
                        message: 'Could not create session.'
                    }
                }
            })
            .catch(handleApiError)
    }

    return {
        getClubs: getAll,
        createClub: create
    }
}
